import { MusicalNoteIcon as HeroMusicalNoteIcon } from '@heroicons/react/24/outline';
export const MusicalNoteIcon = HeroMusicalNoteIcon;
